import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "004_payment_owner_guards",
  version: "1.4.0",
  ignoreErrors: [
    "no such table: accounting_payments",
    "no such table: main.accounting_payments",
    "no such table: accounting_receipts",
    "no such table: main.accounting_receipts",
  ],
  sql: `
INSERT OR IGNORE INTO \`accounting_receipts\` (
  \`id\`,
  \`payment_no\`,
  \`company_id\`,
  \`branch_id\`,
  \`payment_type\`,
  \`party_type\`,
  \`party_id\`,
  \`payment_date\`,
  \`payment_method\`,
  \`amount\`,
  \`reference_no\`,
  \`bank_account_id\`,
  \`receipt_url\`,
  \`doc_status\`,
  \`status\`,
  \`currency_code\`,
  \`exchange_rate\`,
  \`remarks\`,
  \`reference_module\`,
  \`reference_doctype\`,
  \`reference_id\`,
  \`created_by\`,
  \`created_at\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
)
SELECT
  \`id\`,
  \`payment_no\`,
  \`company_id\`,
  \`branch_id\`,
  'receive',
  'customer',
  \`party_id\`,
  \`payment_date\`,
  \`payment_method\`,
  \`amount\`,
  \`reference_no\`,
  \`bank_account_id\`,
  \`receipt_url\`,
  \`doc_status\`,
  \`status\`,
  \`currency_code\`,
  \`exchange_rate\`,
  \`remarks\`,
  \`reference_module\`,
  \`reference_doctype\`,
  \`reference_id\`,
  \`created_by\`,
  \`created_at\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
FROM \`accounting_payments\`
WHERE \`payment_type\` = 'receive';

CREATE TRIGGER IF NOT EXISTS \`accounting_payments_owner_insert_guard\` BEFORE INSERT ON \`accounting_payments\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'pay' BEGIN SELECT RAISE(ABORT, 'accounting_payments owner discriminator violation'); END;

CREATE TRIGGER IF NOT EXISTS \`accounting_payments_owner_update_guard\` BEFORE UPDATE OF \`payment_type\` ON \`accounting_payments\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'pay' BEGIN SELECT RAISE(ABORT, 'accounting_payments owner discriminator violation'); END;

CREATE TRIGGER IF NOT EXISTS \`accounting_receipts_owner_insert_guard\` BEFORE INSERT ON \`accounting_receipts\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'receive' BEGIN SELECT RAISE(ABORT, 'accounting_receipts owner discriminator violation'); END;

CREATE TRIGGER IF NOT EXISTS \`accounting_receipts_owner_update_guard\` BEFORE UPDATE OF \`payment_type\` ON \`accounting_receipts\` FOR EACH ROW WHEN NEW.\`payment_type\` <> 'receive' BEGIN SELECT RAISE(ABORT, 'accounting_receipts owner discriminator violation'); END;
  `.trim(),
};
